import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';

import { AlertService } from "../../services/alert/alert.service";
import { Iceutility } from "../../services/iceutility";
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';
import { payer } from '../../models/domain/payer';
import { IceTypes } from '../../models/icetypes';

declare var require: any;

@Injectable({
  providedIn: 'root'
})
export class PayerService extends DomainService {

  constructor(http: HttpClient,
    alertSvc: AlertService,
    loginSvc: LoginService) {

    super(http, alertSvc, loginSvc);
  }

  insertPayer(pyr: payer, members: string): Observable<any> {
    if (Iceutility.isdefined(pyr) == false) throw "Payer service Insert payer has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Payer service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/payers/default.aspx?domain=&data=addpayer&key=&subkeys=" + "members:" + (members == null ? "" : members);
    let tblname = pyr.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pyr) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PAYER"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  updatePayer(pyr: payer): Observable<any> {
    if (Iceutility.isdefined(pyr) == false) throw "Payer service Insert payer has invalid parameters.";

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Payer service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/payers/default.aspx?domain=" + pyr.trans_account + "&data=updatepayer&key=&subkeys=domaintype:;lastname:";
    let tblname = pyr.gettablename().toLowerCase();
    let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(pyr) + "}";
    return this.getHttp().post(url, data, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PAYER"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }

  public getPayers(): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Payer service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/payers/default.aspx?domain=&data=&key=&subkeys=";
    return this.getHttp().get(url, { responseType: 'text' }).pipe(
      map(
        response => this.geticexdocumentobjects(response, ["PAYER_INDEX"])
      ),
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error))
    );
  }
}
